<template>
  <div class="self-service-select-container">
    <vs-row vs-justify="center" vs-align="center" class="button-row">
      <vs-col vs-w="6" vs-lg="6" vs-sm="12" class="text-center button-col">
        <vs-button
          size="large"
          color="primary"
          class="service-button"
          @click="navigateTo('/pages/selfservice')"
        >
          Masalı Sıcak Satış
        </vs-button>
      </vs-col>
      <vs-col vs-w="6" vs-lg="6" vs-sm="12" class="text-center button-col">
        <vs-button
          size="large"
          color="success"
          class="service-button"
          @click="navigateTo('/pages/selfservice2?notSwitch=false')"
        >
          Masasız Sıcak Satış
        </vs-button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
export default {
  name: 'SelfServiceSelect',
  setting:{},
  created() {
    const activeUser = this.$store.state.AppActiveUser;
    if (!activeUser || !activeUser.branch) {
      console.warn("SelfServiceSelect: AppActiveUser not loaded, redirecting to home");
      this.$router.push('/');
      return;
    }

    this.setting = activeUser.branch.setting || {};
    const userRole = activeUser.userRole;
    
    if(!this.setting.deskModuleEnabled)
    {
      this.$router.push('/pages/selfservice2?notSwitch=false');
      return;
    }

    if (userRole === 'admin') {
      this.$router.push('/pages/selfservice');
      return;
    }
  },
  methods: {
    navigateTo(path) {
      this.$router.push(path);
    }
  }
}
</script>

<style scoped>
.self-service-select-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.button-row {
  width: 100%;
}

.button-col {
  margin: 10px 0;
}

.service-button {
  width: 100%;
  height: 180px;
  font-size: 28px !important;
  font-weight: bold !important;
}

@media (max-width: 576px) {
  .service-button {
    height: 150px;
    font-size: 22x !important;
  }
}
</style>
